module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-01@2x-b951c7d37198dd36901bc77de6eb2635.png";